"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannerImpression = void 0;
var bannerImpression = function (event) {
    var _a, _b;
    return {
        event: 'bannerimpression',
        eventInfo: 'bannerimpression',
        action: 'bannerimpression',
        banner: {
            bannerName: (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.banner) === null || _b === void 0 ? void 0 : _b.bannerName,
        }
    };
};
exports.bannerImpression = bannerImpression;
